import { makeStyles } from '@material-ui/core';

import { pdvColor, pdvRadius, pdvShadow } from 'componentsV2/pdv/tokens';

/* The prototype's rm-* (report modal) and fb-* (feedback) rules; the dialog shell,
   buttons and tabs come from componentsV2/pdv. */
export const useStyles = makeStyles({
  segment: { padding: '12px 0' },
  select: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
    minHeight: 42,
    padding: '8px 12px',
    borderRadius: pdvRadius.s,
    border: `1px solid ${pdvColor.borderStrong}`,
    background: pdvColor.surfacePage,
    font: 'inherit',
    fontSize: 14,
    lineHeight: '24px',
    color: pdvColor.textPrimary,
    textAlign: 'left',
    cursor: 'pointer',
    '& svg': { transition: 'transform .15s' },
    '&:focus-visible': { outline: 'none', borderColor: pdvColor.brand }
  },
  selectOpen: { borderColor: pdvColor.brand },
  chevronClosed: { transform: 'rotate(180deg)' },
  placeholder: { color: pdvColor.textSecondary },
  menu: {
    marginTop: 4,
    padding: '4px 0',
    borderRadius: pdvRadius.l,
    border: `1px solid ${pdvColor.border}`,
    background: pdvColor.surface,
    boxShadow: pdvShadow.menu
  },
  menuSearch: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    margin: '0 12px',
    padding: '8px 0',
    borderBottom: `1px solid ${pdvColor.borderStrong}`,
    color: pdvColor.textSecondary,
    '& input': {
      flex: 1,
      minWidth: 0,
      border: 0,
      outline: 0,
      background: 'none',
      font: 'inherit',
      fontSize: 14,
      color: pdvColor.textPrimary,
      '&::placeholder': { color: pdvColor.textSecondary, opacity: 1 }
    }
  },
  items: { maxHeight: 240, padding: 4, overflowY: 'auto' },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
    minHeight: 48,
    padding: 12,
    border: 0,
    borderRadius: pdvRadius.pill,
    background: 'none',
    font: 'inherit',
    fontSize: 14,
    lineHeight: '20px',
    color: pdvColor.textPrimary,
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': { background: pdvColor.surfacePage }
  },
  itemOn: { background: pdvColor.surfacePage },
  badge: {
    flex: 'none',
    padding: '4px 8px',
    borderRadius: 16,
    border: `1px solid ${pdvColor.borderStrong}`,
    color: pdvColor.textSecondary,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px'
  },
  badgeMine: { color: pdvColor.success, borderColor: pdvColor.success },
  empty: {
    margin: 0,
    padding: 12,
    fontSize: 14,
    color: pdvColor.textSecondary
  },
  sentCount: { color: pdvColor.success },
  triggers: { display: 'flex', alignItems: 'center', gap: 8 },

  /* the rep's Feedback list */
  list: { display: 'flex', flexDirection: 'column', gap: 12 },
  /* the same list as the product dialog's Feedback tab */
  tab: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    flex: 1,
    minWidth: 0,
    overflowY: 'auto'
  },
  tabSkeleton: { borderRadius: 16, flex: 'none' },
  tabEmpty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    /* fills the tab down to the footer */
    flex: 1,
    minHeight: 240,
    borderRadius: 16,
    background: pdvColor.surface,
    textAlign: 'center',
    '& strong': {
      fontSize: 16,
      fontWeight: 600,
      color: pdvColor.textPrimary
    },
    '& span': { fontSize: 14, color: pdvColor.textSecondary }
  },
  fbCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: '12px 16px',
    borderRadius: 16,
    background: pdvColor.surface
  },
  fbHead: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 10,
    paddingBottom: 4,
    fontSize: 14,
    '& strong': {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '24px',
      color: pdvColor.textPrimary
    }
  },
  status: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: pdvRadius.pill,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    whiteSpace: 'nowrap'
  },
  date: {
    marginLeft: 'auto',
    fontSize: 12,
    lineHeight: '16px',
    color: pdvColor.textSecondary
  },
  fields: {
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& > div': {
      display: 'grid',
      gridTemplateColumns: '170px 1fr',
      gap: 16,
      fontSize: 14
    },
    '& dt': { color: pdvColor.textSecondary, fontWeight: 600 },
    '& dd': { margin: 0, overflowWrap: 'anywhere' }
  },
  historyHead: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '10px 0',
    border: 0,
    background: 'none',
    font: 'inherit',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    cursor: 'pointer'
  },
  history: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    fontSize: 13,
    color: pdvColor.textSecondary
  }
});
